module.exports = __webpack_public_path__ + "img/icon_coupon.d8e0b870.png";